import { getSession as getClientSession } from 'next-auth/react';
import { cache } from 'react';

// getServerSession は session コールバックで goods-me を fetch するため、1リクエスト内で
// 複数レイアウト/ページから呼ぶと重複 fetch になる。React の cache() で1回に畳む（GF-2374）。
// cache は Server Component 専用 API。vitest が解決する react は cache を export しないため、
// import は通るが実体が undefined になる。外すと 136 テストが cache is not a function で落ちる。
const memoizePerRequest: typeof cache = typeof cache === 'function' ? cache : (fn) => fn;

const getServerSessionCached = memoizePerRequest(async () => {
  const { getServerSession } = await import('next-auth/next');
  const { authOptions } = await import('@/app/api/auth/[...nextauth]/route');
  return await getServerSession(authOptions);
});

/**
 * 実行環境に応じてセッション取得を振り分ける。
 * 経路が分かれるのは next-auth の仕様で揃えられない。揃えられるのはセッションの形と
 * 判定式（utils/auth の isLoggedIn）だけ。
 */
export async function getSession() {
  const isClient = typeof window !== 'undefined';
  if (isClient) {
    // クライアントでのセッション取得: /api/auth/session 経由。
    // ブラウザは httpOnly Cookie を読めず secret も持たないため自力復号できない
    return await getClientSession();
  }
  // サーバでのセッション取得: Cookie の JWT を直接復号する
  return await getServerSessionCached();
}
